<template>
  <div class="login">
    <SystemTopbar title="登录"></SystemTopbar>
    <div class="content">
      <div class="content-row">
        <div class="content-left">
          <img src="../../assets/img/易查X-EPC@2X.png" />
          <p>汽配精准查找，从这里开始</p>
        </div>
        <div class="content-right">
          <p class="form-title">登录</p>
          <el-form
            :model="user"
            status-icon
            :rules="rules"
            ref="user"
            class="demo-ruleForm"
          >
            <el-form-item prop="userName">
              <el-input
                type="userName"
                placeholder="输入用户名"
                v-model="user.userName"
                auto-complete="off"
              >
                <i slot="prefix" class="iconfont icon-yonghu"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                placeholder="输入密码"
                v-model="user.password"
                auto-complete="off"
              >
                <i slot="prefix" class="iconfont icon-mima"></i>
              </el-input>
            </el-form-item>
            <el-row type="flex" justify="space-between">
              <el-checkbox label="10天内自动登录" name="type"></el-checkbox>
              <span class="removepass-span">忘记密码？</span>
            </el-row>
            <el-form-item>
              <el-button
                class="form-btn"
                type="primary"
                @click="postLogin('user')"
                >登 录</el-button
              >
            </el-form-item>
          </el-form>
          <!-- <div class="login-footer">
            <span class="footer_username">还没有账号?</span>
						<span class="footer_register">立即注册>></span>
          </div> -->
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import request from "@/lib/axios";
import SystemTopbar from "@/components/system/systemTopbar";
import Footer from "@/components/footer/footer.vue";
export default {
  components: {
    SystemTopbar,
    Footer
  },
  data() {
    return {
      user: {
        userName: "",
        password: ""
      },
      rules: {
        userName: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  methods: {
    jumpHome() {
      this.$router.push("/");
    },
    postLogin(formName) {
      this.$refs[formName].validate(valid => {
        /* this.axios({
          method: "post",
          baseURL: "/login",
          url: "/getToken",
          params: {
            userName: this.user.userName,
            password: this.$md5(this.user.password),
            timestamp: (new Date()).valueOf()
          }
        })
          .then(res => { */
        request({
          method: "post",
          baseURL: "/login",
          url: "/getToken",
          params: {
            userName: this.user.userName,
            password: this.$md5(this.user.password),
            timestamp: new Date().valueOf()
          }
        }).then(res => {
          if (res.data.status == "0") {
            let value = this.$md5(
              this.$md5(this.user.password) + res.data.data
            );
            this.$store.commit("changeLonginToken", res.data.data);
            this.$store.commit("changeAuthorization", value);
            this.$router.push("/");
          } else {
            this.$message.error(res.data.message);
          }
        });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/custom.scss";
.content {
  min-width: $width;
  height: 600px;
  background: linear-gradient(
    270deg,
    rgba(0, 183, 250, 1) 0%,
    rgba(1, 53, 125, 1) 100%
  );

  .content-row {
    width: $width;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .content-left {
      p {
        margin: 20px 10px;
        padding: 0;
        font-size: 33px;
        line-height: 45px;
        color: $white-color;
      }
    }

    .content-right {
      width: 300px;
      background: $white-color;
      padding: 20px;

      .form-title {
        margin: 0 0 25px 0;
        padding-bottom: 10px;
        color: $main-color;
        font-size: 17px;
        font-weight: 800;
        border-bottom: 2px solid #dcdfe6;
      }

      .removepass-span {
        font-size: 12px;
        color: $main-color;
        line-height: 19px;

        &:hover {
          color: rgba(2, 133, 201, 0.8);
          cursor: pointer;
        }
      }

      .form-btn {
        width: 100%;
        background: $main-color;
        margin-top: 20px;
        font-size: 20px;

        &:hover {
          background: rgba(2, 133, 201, 0.8);
        }
      }

      .login-footer {
        height: 50px;
        border-top: 2px solid #dcdfe6;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .footer_username {
          font-size: 14px;
          color: #6f6f6f;
        }

        .footer_register {
          font-size: 14px;
          color: $main-color;
          &:hover {
            cursor: pointer;
            color: rgba(2, 133, 201, 0.8);
          }
        }
      }
    }
  }
}
</style>
